<template>
  <div class="home">
    <div class="header">
      <el-row :gutter="20">
        <el-col :span="12">
          <div>
            <!-- 订单日期
            <el-date-picker size="mini" v-model="value1" type="date" placeholder="选择日期"></el-date-picker>至
            <el-date-picker size="mini" v-model="value1" type="date" placeholder="选择日期"></el-date-picker> -->
            <el-select @change="getList()" class="input-search" size="mini" v-model="listQuery.status" placeholder="开票状态" style="width:130px">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input class="input-search" size="mini" v-model="listQuery.fpdm" placeholder="发票代码" />
            <el-input class="input-search" size="mini" v-model="listQuery.fphm" placeholder="发票号码" />
            <el-button size="mini" type="primary" @click="getList()">搜索</el-button>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="right">
            <el-button @click="getList()" size="mini" type="primary" plain>刷新</el-button>
            <el-button @click="printAll()" size="mini" type="success" plain>打印</el-button>
            <el-button @click="setting()" size="mini" type="success" plain>打印机设置</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    
    
    <el-table size="mini" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="{background:'#66b1ff',color:'#ffff'}">
      <el-table-column type="selection" width="55" align="center"/>
      <el-table-column fixed type="index" width="50" label="序号" align="center" :index="computeTableIndex"></el-table-column>
      <el-table-column label="开票状态" width="160" align="center">
        <template v-slot="scope">
          <el-tooltip
           class="item"
           effect="dark"
           :content="scope.row.msg"
           placement="top-start"
           :disabled="!scope.row.msg"
          >
          <span class="shubiao" :style="{color:(scope.row.status==1?'green':'red')}">{{ statusFilters(scope.row.status) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="kprq" label="开票日期" width="120" align="center"/>
      <!-- <el-table-column prop="msg" label="提示" width="120" align="center"/> -->
      <el-table-column prop="fpdm" label="发票代码" width="200" align="center"/>
      <el-table-column prop="fphm" label="发票号码" width="120" align="center"/>
      <el-table-column label="发票类型" width="160" align="center">
        <template v-slot="scope">
         <span>{{ $fplx(scope.row.fplxdm) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="kplx" label="开票类型" width="120" align="center">
        <template v-slot="scope">
          {{filter(scope.row.kplx)}}
        </template>
      </el-table-column>
      <el-table-column prop="fpqqlsh" label="发票请求流水号" width="210" align="center"/>
      <el-table-column prop="xhdwmc" label="销货单位名称" width="180" align="center"/>
      <el-table-column prop="ghdwmc" label="购货单位名称" width="120" align="center"/>
      <el-table-column prop="jshj" label="价税合计" width="110" align="center"/>
      <el-table-column prop="hjje" label="合计金额" width="160" align="center"/>
      <el-table-column prop="hjse" label="合计税额" width="120" align="center"/>
      <el-table-column prop="kce" label="差额征税扣除额" width="110" align="center"/>

      <el-table-column label="二维码" width="160" align="center">
        <template v-slot="scope">
          <img class="img-ewm" :src="findSrc(scope.row.ewm)" alt="">
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="200" align="center">
       <template v-slot="scope">
          <el-button type="text" size="small" @click="handleClick(scope.row)">明细</el-button>
          <el-button v-if="scope.row.fphm" type="text" size="small" @click="print(scope.row)">预览打印</el-button>
          <el-button v-if="scope.row.fphm && scope.row.qdbz == '1'" type="text" size="small" @click="printQd(scope.row)">清单预览打印</el-button>
       </template>
      </el-table-column>
    </el-table>
  </div>
  <div class="pagination">
    <qzf-pagination v-show="total>0" :total="total" v-model:page="listQuery.page" v-model:limit="listQuery.limit" @pagination="getList" />
  </div>
  <invoice-detail :row=row ref="invoiceDetail"></invoice-detail>
</template>
<script>
import { defineComponent, ref, onBeforeUnmount } from 'vue'
import { invoiceList } from "@/api/open";
import { getInvoicePrintInfo } from "@/api/apply";
import router from '@/router/index.js'

import { XMLTOJSON, formatData } from '@/utils/fun'

// function XMLTOJSON(xml) {
//   var x2js = new X2JS();
//   var json = x2js.xml_str2json(xml);
//   var business = json.business;
//   var body = business.body;
//   var returndata = body.returndata;
//   var kpxx = returndata.kpxx;
//   var group = kpxx.group;
//   return group
// }


// // 格式化数据
// function formatData(xml) {
//   const _xml = JSON.parse(JSON.stringify(xml))
//   if (!Array.isArray(_xml.fyxm.group)) {
//     _xml.zbmx = [_xml.fyxm.group]
//   } else {
//     _xml.zbmx = _xml.fyxm.group
//   }
//   _xml.ghdwdm = _xml.ghdwsbh
//   _xml.xhdwdm = _xml.xhdwsbh

//   // 需要转化为numnber的数据
//   _xml.hjje = _xml.hjje ? Number(_xml.hjje) : ''
//   _xml.hjzkje = _xml.hjzkje ? Number(_xml.hjzkje) : ''
//   _xml.hjzkse = _xml.hjzkse ? Number(_xml.hjzkse) : ''
//   _xml.jshj = _xml.jshj ? Number(_xml.jshj) : ''
//   _xml.se = _xml.hjse ? Number(_xml.hjse) : ''
//   _xml.zhsl = _xml.zhsl ? Number(_xml.zhsl) : ''
//   _xml.hjse = _xml.hjse ? Number(_xml.hjse) : ''
//   console.log(_xml.hjse);
//   _xml.zbmx.forEach(item => {
//     item.fphxz = item.fphxz ? Number(item.fphxz) : ''
//     item.fpmxxh = item.fpmxxh ? Number(item.fpmxxh) : ''
//     item.je = item.je ? Number(item.je) : ''
//     item.se = item.se ? Number(item.se) : ''
//     item.sl = item.sl ? Number(item.sl) : ''
//     item.spdj = item.spdj ? Number(item.spdj) : ''
//     item.spsl = item.spsl ? Number(item.spsl) : ''
//   })

//   return _xml
// }


export default {
  name: 'queryPrint',
  mounted () {
    console.log("2挂载完成") 
  },
  data() {
    return {
      listQuery: {
        comId: this.$store.getters['user/comInfo'].id*1,
        page: 1,
        limit: 10,
        fpdm: "",
        fphm: "",
        status: 1,
      },
      options: [
        {
          value: 0,
          label: '全部',
        },
        {
          value: 1,
          label: '开票成功',
        },
        {
          value: 2,
          label: '开票失败',
        },
        {
          value: 3,
          label: '开票作废',
        }
      ],
      total: 0,
      tableData: [],
      selects: [],
      row:{}
    }
  },
  created () {
      // let daysz = {
      //   dyqxzdyj: !1,
      //   zbj_zzsp: "-10",
      //   ybj_zzsp: "0",
      //   sbj_zzsz: "0",
      //   zbj_zzsz: "-10",
      //   sbj_zzsp_qd: "0",
      //   zbj_zzsp_qd: "-5",
      //   sbj_zzsz_qd: "0",
      //   zbj_zzsz_qd: "-5",
      //   zbj_jp: "-10",
      //   ybj_jp: "0",
      //   jqxzbs: "0",
      //   sfdyewm: !1,
      //   jdcsbz: "0",
      //   jdczbz: "0",
      //   escsbz: "0",
      //   esczbz: "0",
      //   bans: "06",
      //   zzsp_width: "230",
      //   zzsp_height: "140",
      //   zzsz_width: "230",
      //   zzsz_height: "140"
      // }
      // localStorage.setItem('key', JSON.stringify(daysz))
    this.getList()
  },
  methods: {
    handleSelectionChange(e){
      this.selects = e.map(v=>{return v.id})
      console.log(this.selects)
    },
    printAll(){
      if(this.selects.length == 0){
        this.$qzfMessage("请至少选择一个", 1)
        return
      }
      // return
      let keys = window.localStorage.getItem("key")?JSON.parse(window.localStorage.getItem("key")):{}
      getInvoicePrintInfo({ids: this.selects}).then(res=>{
        if(res.data.msg == "success"){
          let xmls = res.data.data.infos
          xmls.map(v=>{
            let xml = XMLTOJSON(v.xml)
            xml = formatData(xml)
            if(v.fplxdm == "007"){
              ZzspFpdy(xml,'1',keys.ybj_zzsp, keys.zbj_zzsp)//传入打印报文  是否的打印  上边距 左边距
            }else if(v.fplxdm == "004"){
              ZzszFpdy(xml,'1',keys.ybj_zzsz, keys.zbj_zzsz)//传入打印报文  是否的打印  上边距 左边距
            }else{
              this.$qzfMessage("电子发票不支持打印", 2)
            }
          })
        }
      })
    },
    //打印
    print(row){
      console.log(localStorage.getItem('key'))
      getInvoicePrintInfo({ids: [row.id*1]}).then(res=>{
        if(res.data.msg == "success"){
          let data = res.data.data.infos[0]

          let xml = XMLTOJSON(data.xml)
          xml = formatData(xml)
          let keys = window.localStorage.getItem("key")?JSON.parse(window.localStorage.getItem("key")):{}
          if(data.fplxdm == "007"){
            ZzspFpdy(xml,'0',keys.ybj_zzsp, keys.zbj_zzsp)//传入打印报文  是否的打印  上边距 左边距
          }else if(data.fplxdm == "004"){
            ZzszFpdy(xml,'0',keys.ybj_zzsz, keys.zbj_zzsz)//传入打印报文  是否的打印  上边距 左边距
          }else{
            this.$qzfMessage("电子发票不支持打印", 2)
          }
        }
      })
    },
    printQd(row){
      let keys = window.localStorage.getItem("key")?JSON.parse(window.localStorage.getItem("key")):{}
      getInvoicePrintInfo({ids: [row.id*1]}).then(res=>{
        if(res.data.msg == "success"){
          let data = res.data.data.infos[0]

          let xml = XMLTOJSON(data.xml)
          xml = formatData(xml, true)
          if(data.fplxdm == "007"){
            Zzspqddy(xml,'0',keys.ybj_qd_zzsp, keys.zbj_qd_zzsp)//传入打印报文  是否的打印  上边距 左边距
          }else if(data.fplxdm == "004"){
            Zzszqddy(xml,'0',keys.ybj_qd_zzsz, keys.zbj_qd_zzsz)//传入打印报文  是否的打印  上边距 左边距
          }else{
            this.$qzfMessage("电子发票不支持打印", 2)
          }
        }
      })
    },
    findSrc(base64){
      return "data:image/png;base64," + base64
    },
    statusFilters(e){
      if(e == 1){
        return "开票成功"
      }else if(e == 3){
        return "开票作废"
      }else{
        return "开票失败"
      }
    },
    filter(n){
      if(n == "0"){
        return "正数票开具"
      }else{
        return "负数票开具"
      }
    },
    getList(){
      invoiceList(this.listQuery).then(res=>{
        this.total = res.data.data.total
        if(res.data.data.list){
          this.tableData = res.data.data.list
        }
      })
    },
    handleClick(row) {
      this.row = row
      this.$refs.invoiceDetail.dialogVisible = true
    },
    //序号
    computeTableIndex(index) {
      return (this.listQuery.page - 1) * this.listQuery.limit + index + 1
    },
    setting(){
      router.push( "/setting/print");
    }
  },
  activated () {
    
  },
  setup() {
    onBeforeUnmount(()=>{
      console.log("2销毁")
    })
  },
}
</script>
<style lang="scss" scoped>
.home{
  padding: 10px;
  .header{
    margin-bottom: 10px;
    .right{
      float: right;
    }
    .input-search{
      width: 180px;
      margin-right: 5px;
    }
  }
  .img-ewm{
    width: 50px;
  }
}
.pagination{
  text-align: right;
  margin-right: 26px;
  margin-top: 16px;
}
.el-table{
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
}
</style>